import { Injectable } from '@angular/core';
import {
  DataPageDefault,
  DataQueryParamPage,
  DataQueryParamFrom,
  DataQueryParamTo,
  DataStartedAt,
  DataQueryParamModuleName,
  DataModuleEntity,
} from '@edgvr-front/data/domain';
import {
  createEffect,
  Actions,
  ofType,
  EffectNotification,
  concatLatestFrom,
} from '@ngrx/effects';
import { getSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import {
  catchError,
  exhaustMap,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { DataModuleModulesListPageActions } from '../actions';
import { DataModulesListRequestDTO } from '../dto';
import { DataService } from '../services';

const { selectRouteParams, selectQueryParams } = getSelectors();

@Injectable()
export class DataModuleModulesListPageEffects {
  init$ = createEffect(() =>
    this.store.select(selectRouteParams).pipe(
      concatLatestFrom(() => [this.store.select(selectQueryParams)]),
      mergeMap(([_, queryParams]) => [
        DataModuleModulesListPageActions.dataModulesList({
          page: Number(queryParams[DataQueryParamPage]) || DataPageDefault,
          moduleName: queryParams[DataQueryParamModuleName],
          from:
            (Number(queryParams[DataQueryParamFrom]) as DataStartedAt) ||
            undefined,
          to:
            (Number(queryParams[DataQueryParamTo]) as DataStartedAt) ||
            undefined,
        }),
      ])
    )
  );

  dataModulesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataModuleModulesListPageActions.dataModulesList),
      switchMap(({ page, moduleName, from, to }) =>
        this.dataService
          .dataModulesList(
            new DataModulesListRequestDTO({
              page,
              moduleName,
              from,
              to,
            })
          )
          .pipe(
            mergeMap((_) => [
              DataModuleModulesListPageActions.dataModulesListSuccess({
                dataModules: _.data.dataModules.map((_) =>
                  DataModuleEntity.factory(_)
                ),
                count: _.data.count,
                page,
              }),
            ]),
            catchError((_) => {
              this.store.dispatch(
                DataModuleModulesListPageActions.dataModulesListFailure()
              );

              return throwError(() => _);
            })
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly dataService: DataService
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(DataModuleModulesListPageActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(
            this.actions$.pipe(ofType(DataModuleModulesListPageActions.destroy))
          )
        )
      )
    );
  }
}
